(function () {
  const popup = document.getElementById('sold-out-popup');
  if (!popup) return;

  function openPopup() { popup.classList.add('is-open'); }
  function closePopup() { popup.classList.remove('is-open'); }

  popup.querySelector('.sop-backdrop').addEventListener('click', closePopup);
  popup.querySelector('.sop-close').addEventListener('click', closePopup);
  popup.querySelector('.sop-dismiss-btn').addEventListener('click', closePopup);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closePopup(); });

  const qtyContainer = document.querySelector('[id^="Quantity-Form-"]');
  if (!qtyContainer) return;

  const plusBtn = qtyContainer.querySelector('.quantity__button[name="plus"]');

  let soldOut = false;

  const plusBtnObserver = plusBtn
    ? new MutationObserver(() => {
        if (soldOut && plusBtn.hasAttribute('disabled')) {
          plusBtn.removeAttribute('disabled');
        }
      })
    : null;

  function setSoldOut(isSoldOut) {
    const wasSoldOut = soldOut;
    soldOut = isSoldOut;

    if (soldOut) {
      if (plusBtn) {
        plusBtn.removeAttribute('disabled');
        if (!wasSoldOut) {
          plusBtnObserver.observe(plusBtn, { attributes: true, attributeFilter: ['disabled'] });
        }
      }
    } else {
      plusBtnObserver?.disconnect();
      closePopup();
    }
  }

  // Capture-phase listener — intercepts quantity-area clicks before disabled-button suppression.
  document.addEventListener('click', function (e) {
    if (!soldOut) return;
    if (!qtyContainer.contains(e.target)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const qtyEl = qtyContainer.querySelector('quantity-input');
    if (qtyEl) {
      qtyEl.classList.add('sop-shake');
      qtyEl.addEventListener('animationend', () => qtyEl.classList.remove('sop-shake'), { once: true });
    }
    openPopup();
  }, true);

  // Watch the badge wrapper for price__badge-sold-out appearing/disappearing.
  // buildInventoryUI/updateSoldOutUI updates this badge AFTER the inventory fetch
  // completes — making it the authoritative signal for sold-out state.
  const badgeWrapper = document.querySelector('.product__info-container .badges-wrapper');
  if (!badgeWrapper) return;

  function checkBadge() {
    setSoldOut(!!badgeWrapper.querySelector('.price__badge-sold-out'));
  }

  new MutationObserver(checkBadge).observe(badgeWrapper, { childList: true, subtree: true });
})();
